import * as React from 'react';

import { EHeatingType, getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { HeatingType } from '../../../components/advancedFilters/HeatingType';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const HeatingTypeContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const heatingTypes = getTermsValue('heating_source_type')(jsonQuery);

  const handleChange = React.useCallback(
    (heatingTypes: NonEmptyArray<EHeatingType> | null) => {
      onChange({ action: 'setHeatingTypes', arguments: [heatingTypes] });
    },
    [onChange],
  );

  return <HeatingType value={heatingTypes as NonEmptyArray<EHeatingType> | null} onChange={handleChange} />;
};
